import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Img = styled.img`
  width: ${spacing(10)};
  height: ${spacing(10)};
`;
